import { ReactComponent as Done } from "../../assets/icons/add.svg";
import { ReactComponent as Plus } from "../../assets/icons/add-icon.svg";
import { ReactComponent as Question } from "../../assets/icons/question-mark.svg";
import { ReactComponent as ListGray } from "../../assets/icons/list_gray_ic.svg";
import { ReactComponent as Grid } from "../../assets/icons/grid_grey_ic.svg";
import { ReactComponent as Lock } from "../../assets/icons/lock.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { ReactComponent as CloseWhite } from "../../assets/icons/close-white.svg";
import { ReactComponent as CheckedRadio } from "../../assets/icons/checked.svg";
import { ReactComponent as UnCheckedRadio } from "../../assets/icons/unchecked.svg";
import { ReactComponent as CheckOutline } from "../../assets/icons/check_outline_ic.svg";
import { ReactComponent as CheckedIcon } from "../../assets/icons/on.svg";
import { ReactComponent as UncheckedIcon } from "../../assets/icons/Rectangle.svg";
import { ReactComponent as Brief } from "../../assets/icons/brief.svg";
import { ReactComponent as AccountDetails } from "../../assets/icons/account_details.svg";
import { ReactComponent as SigningPreferences } from "../../assets/icons/signing_preferences.svg";
import { ReactComponent as Channels } from "../../assets/icons/channels.svg";
import { ReactComponent as ValueAddedServices } from "../../assets/icons/value_added_services.svg";
import { ReactComponent as QuestionMarkGray } from "../../assets/icons/question_mark_grey.svg";
import { ReactComponent as Info } from "../../assets/icons/info.svg";
import { ReactComponent as InfoYellow } from "../../assets/icons/infoYellow.svg";
import { ReactComponent as InfoRed } from "../../assets/icons/infoRed.svg";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrowDown.svg";
import { ReactComponent as Error } from "../../assets/images/error.svg";
import { ReactComponent as File } from "../../assets/icons/file.svg";
import { ReactComponent as MinimizeChat } from "../../assets/icons/chat-minimize.svg";
import { ReactComponent as Bolt } from "../../assets/icons/bolt.svg";
import { ReactComponent as KycAnnexure } from "../../assets/icons/kyc_annexure.svg";
import { ReactComponent as ArrowUp } from "../../assets/icons/arrowUp.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/editIcon.svg";
import { ReactComponent as ArrowLeft } from "../../assets/icons/arrowLeft.svg";
import { ReactComponent as ArrowRight } from "../../assets/icons/arrowRight.svg";
import { ReactComponent as AedFlag } from "../../assets/images/icons/aed_flag.svg";
import { ReactComponent as UsdFlag } from "../../assets/images/icons/usd_flag.svg";
import { ReactComponent as EuroFlag } from "../../assets/images/icons/euro_flag.svg";
import { ReactComponent as GbpFlag } from "../../assets/images/icons/gbp.svg";
import { ReactComponent as SoleCustomer } from "../../assets/icons/Sole.svg";
import { ReactComponent as MultiPatner } from "../../assets/icons/MultiPatner.svg";
import { ReactComponent as Patnership } from "../../assets/icons/Patnership.svg";
import { ReactComponent as InActive } from "../../assets/icons/progressbar/active.svg";
import { ReactComponent as Active } from "../../assets/icons/progressbar/inActive.svg";
import { ReactComponent as Completed } from "../../assets/icons/progressbar/completed.svg";
import { ReactComponent as ProgressIcon } from "../../assets/icons/progressbar/progressIconMobile.svg";

export const iconComponents = {
  done: Done,
  plus: Plus,
  question: Question,
  listGray: ListGray,
  grid: Grid,
  lock: Lock,
  close: Close,
  closeWhite: CloseWhite,
  checkedRadio: CheckedRadio,
  unCheckedRadio: UnCheckedRadio,
  checkOutline: CheckOutline,
  checkedIcon: CheckedIcon,
  uncheckedIcon: UncheckedIcon,
  brief: Brief,
  accountDetails: AccountDetails,
  signingPreferences: SigningPreferences,
  channels: Channels,
  valueAddedServices: ValueAddedServices,
  questionMarkGray: QuestionMarkGray,
  info: Info,
  infoYellow: InfoYellow,
  infoRed: InfoRed,
  arrowDown: ArrowDown,
  error: Error,
  file: File,
  minimizeChat: MinimizeChat,
  bolt: Bolt,
  kycAnnexure: KycAnnexure,
  arrowUp: ArrowUp,
  editIcon: EditIcon,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  aedFlag: AedFlag,
  usdFlag: UsdFlag,
  euroFlag: EuroFlag,
  gbpFlag: GbpFlag,
  soleCustomer: SoleCustomer,
  multiPatner: MultiPatner,
  patnership: Patnership,
  inActive: InActive,
  active: Active,
  completed: Completed,
  progressIcon: ProgressIcon
};

export const ICONS = {
  done: "done",
  plus: "plus",
  question: "question",
  listGray: "listGray",
  grid: "grid",
  lock: "lock",
  close: "close",
  closeWhite: "closeWhite",
  checkedRadio: "checkedRadio",
  unCheckedRadio: "unCheckedRadio",
  checkOutline: "checkOutline",
  checkedIcon: "checkedIcon",
  uncheckedIcon: "uncheckedIcon",
  brief: "brief",
  accountDetails: "accountDetails",
  signingPreferences: "signingPreferences",
  channels: "channels",
  valueAddedServices: "valueAddedServices",
  questionMarkGray: "questionMarkGray",
  info: "info",
  infoYellow: "infoYellow",
  infoRed: "infoRed",
  arrowDown: "arrowDown",
  error: "error",
  file: "file",
  minimizeChat: "minimizeChat",
  bolt: "bolt",
  kycAnnexure: "kycAnnexure",
  arrowUp: "arrowUp",
  editIcon: "editIcon",
  arrowLeft: "arrowLeft",
  arrowRight: "arrowRight",
  aedFlag: "aedFlag",
  usdFlag: "usdFlag",
  euroFlag: "euroFlag",
  gbpFlag: "gbpFlag",
  soleCustomer: "soleCustomer",
  multiPatner: "multiPatner",
  patnership: "patnership",
  inActive: "inActive",
  active: "active",
  completed: "completed",
  progressIcon: "progressIcon"
};
